import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources } from 'react-admin';
import { withRouter } from 'react-router-dom';

const capitalize = str => str[0].toUpperCase() + str.slice(1);

const Menu = ({ resources, onMenuClick }) => (
  <div>
    <MenuItemLink to="/dashboard" primaryText="Dashboard" onClick={onMenuClick} />

    {resources.filter(resource => resource.hasList).map(resource => (
      <MenuItemLink
        key={resource.name}
        to={`/${resource.name}`}
        primaryText={capitalize(resource.name)}
        onClick={onMenuClick}
      />
    ))}
  </div>
);

const mapStateToProps = state => ({
  resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(Menu));



// WEBPACK FOOTER //
// ./src/resources/Menu.jsx